import {
  apiUrl,
  getList,
  getSingleRecord,
  saveRecord,
  deleteRecord,
  getAll,
  getAuditData,
  postAction,
} from './apiUtils';
import type { ApiListParamsWithUnderscores } from '../types/api/listParams';
import type { PromotionItemModel } from '../types/api/promotions';
import type { ListApiResponse } from '../types/apiResponse';

const baseUrl = apiUrl + '/promotions/';

export function getAllPromotions(): Promise<unknown> {
  return getAll(baseUrl);
}

export function getPromotionsByDate(
  from: string,
  to: string,
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(baseUrl + `${from}/${to}/`, params);
}

export function getPromotions(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<unknown>> {
  return getList(`${baseUrl}search`, params);
}

export function getPromotionById(id: string): Promise<PromotionItemModel> {
  return getSingleRecord<PromotionItemModel>(baseUrl, id);
}

export function savePromotion(promotion: unknown): Promise<unknown> {
  return saveRecord(baseUrl, promotion);
}

export function deletePromotion(id: string): Promise<unknown> {
  return deleteRecord(baseUrl, id);
}

export function getAudit(id: string): Promise<unknown> {
  return getAuditData(baseUrl, id);
}

export function addAudit(id: string, comment: string): Promise<unknown> {
  return postAction(`${baseUrl}${id}/audit`, { comment });
}
